// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"AccountProfilePage_layoutWrapperMain__u2Ne4"};